var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { Link, Route, Switch } from "react-router-dom";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'react-dates/constants'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/react-dates/constants.js' implicitly has an 'any' type.
import { START_DATE } from "react-dates/constants";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import AvisoPager from "../../src/View/UI/Pager/Pager";
import Busy from "../shared/busy";
import PersonLookup from "../shared/personLookupNew";
import MessageDetails from "./messageDetails";
import ConfirmOverrideModal from "./confirmOverrideModal";
import Fetcher from "../../services/FetchService";
import twilioErrorCodes from "../../models/TwilioErrorCodes";
import DeprecatedSelect from "../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
import SortableTH from "../../src/View/UI/SortableTH/SortableTH";
import { getMessageReportDetailsPath, getMessageReportDetailsRoute, } from "../../src/View/Pages/Admin/MessageReport/AdminMessageReportRoutes";
import { getXSRF } from "../../src/Services/Shared/FetchService";
const errorCodes = new Map();
errorCodes.set(1, "Missing SMS Phone Type");
errorCodes.set(2, "Phone number limit reached");
errorCodes.set(3, "SMS message limit reached for the month");
errorCodes.set(4, "Recipient opted out");
errorCodes.set(5, "Failed to provision a new number for message sender");
errorCodes.set(6, "Unknown send exception");
errorCodes.set(7, "Unknown update delivery exception");
errorCodes.set(8, "Invalid message body");
errorCodes.set(9, "Invalid subject");
errorCodes.set(10, "Invalid recipient email");
errorCodes.set(100, "SMS not configured");
errorCodes.set(21610, "Attempt to send to unsubscribed recipient");
class MessageReport extends PureComponent {
    constructor(props) {
        super(props);
        this.getMessageStatuses = this.getMessageStatuses.bind(this);
        this.fetchDeliveries = this.fetchDeliveries.bind(this);
        this.filterOnPerson = this.filterOnPerson.bind(this);
        this.filterOnStatus = this.filterOnStatus.bind(this);
        this.filterOnDate = this.filterOnDate.bind(this);
        this.filterOnErrorCode = this.filterOnErrorCode.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.overrideDeliveries = this.overrideDeliveries.bind(this);
        this.setCurrentPage = this.setCurrentPage.bind(this);
        this.setSort = this.setSort.bind(this);
        this.state = {
            loading: false,
            pageSize: 0,
            deliveries: [],
            totalCount: 0,
            searchValue: "",
            errorMesage: "",
            focusedInput: START_DATE,
            filterCriteria: {
                from: null,
                to: null,
                startDate: null,
                endDate: null,
                key: "selection",
                errorCodes: [],
                status: [],
                page: 0,
                asc: true,
                setSort: "id",
            },
            messageCountByStatus: {
                failed: [],
                awaitingSend: 0,
                pending: 0,
                inProcess: 0,
            },
            isModalOpen: false,
            modalMsg: {
                errorCode: 0,
                errorString: "",
            },
            currentPage: 1,
        };
        this.tableHeaders = [
            {
                id: "id",
                name: "ID",
            },
            {
                id: "sender",
                name: "Sender",
            },
            {
                id: "recipient",
                name: "Recipient",
            },
            {
                id: "status",
                name: "Status",
            },
            {
                id: "error",
                name: "Error",
            },
            {
                id: "date",
                name: "Date",
            },
            {
                id: "attempt",
                name: "Attempts",
            },
            {
                id: "destination",
                name: "Destinations",
            },
            {
                id: "sentDestination",
                name: "Successfully Sent Destinations",
            },
        ];
    }
    componentDidMount() {
        this.getMessageStatuses();
        this.fetchDeliveries(this.state.filterCriteria);
    }
    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(prevState.filterCriteria) !==
            JSON.stringify(this.state.filterCriteria)) {
            this.fetchDeliveries(this.state.filterCriteria);
        }
    }
    getMessageStatuses() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch("/aviso/messageReport/getStatus", {
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const result = yield response.json();
            const { awaitingSend, failed, pending, inProcess } = result;
            const messageCountByStatus = {
                awaitingSend,
                failed,
                pending,
                inProcess,
            };
            this.setState({ messageCountByStatus }, () => console.log(this.state));
        });
    }
    overrideDeliveries() {
        return Fetcher.post("/aviso/messageReport/manuallyOverrideDeliveries", {
            errorCode: this.state.modalMsg.errorCode,
        });
    }
    fetchDeliveries(criteria) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ loading: true });
            const response = yield fetch("/aviso/messageReport/getDeliveries", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: JSON.stringify(criteria),
            });
            try {
                const { data: deliveries, pageSize, totalCount } = yield response.json();
                this.setState({ deliveries, pageSize, totalCount, loading: false });
            }
            catch (ex) {
                this.setState({
                    loading: false,
                    errorMesage: "There was an error retreiving your message deliveries",
                });
            }
        });
    }
    filterOnPerson(key, y) {
        const x = {
            filterCriteria: Object.assign(Object.assign({}, this.state.filterCriteria), { page: 0 }),
        };
        if (y) {
            const arrayAffiliationId = [];
            y.forEach((ele) => arrayAffiliationId.push(ele.affiliationId));
            // @ts-expect-error this is old and not worth it to change.
            x.filterCriteria[key] = arrayAffiliationId;
        }
        else {
            // @ts-expect-error this is old and not worth it to change.
            x.filterCriteria[key] = null;
        }
        this.setState(x, () => console.log(this.state));
    }
    filterOnStatus(statusOptions) {
        this.setState({
            filterCriteria: Object.assign(Object.assign({}, this.state.filterCriteria), { status: statusOptions, page: 0 }),
        }, () => console.log(this.state));
    }
    filterOnErrorCode(errorCodesSelected) {
        this.setState({
            filterCriteria: Object.assign(Object.assign({}, this.state.filterCriteria), { errorCodes: errorCodesSelected, page: 0 }),
        }, () => console.log(this.state));
    }
    filterOnDate({ startDate, endDate }) {
        this.setState({
            filterCriteria: Object.assign(Object.assign({}, this.state.filterCriteria), { startDate: startDate && startDate.startOf("day"), endDate: endDate && endDate.endOf("day"), page: 0 }),
        });
    }
    setSort(sortType) {
        if (this.state.filterCriteria.setSort === sortType) {
            this.setState({
                filterCriteria: Object.assign(Object.assign({}, this.state.filterCriteria), { asc: !this.state.filterCriteria.asc, setSort: sortType }),
            });
        }
        else {
            this.setState({
                filterCriteria: Object.assign(Object.assign({}, this.state.filterCriteria), { setSort: sortType, asc: true }),
            });
        }
    }
    getErrorMessage(errorCode) {
        const error = errorCodes.get(errorCode);
        if (error) {
            return error;
        }
        const twilioError = twilioErrorCodes.find((te) => te.code === errorCode);
        if (twilioError) {
            return twilioError.message;
        }
        return "";
    }
    renderDeliveryRow(del) {
        var _a;
        return (_jsxs("tr", { children: [_jsx("td", { children: _jsx(Link, { to: getMessageReportDetailsPath(del.id), children: del.id }) }), _jsx("td", { children: del.sender }), _jsx("td", { children: del.recipient }), _jsx("td", { children: del.status.status }), _jsxs("td", { children: [this.getErrorMessage(del.errorCode), " ", del.errorCode] }), _jsx("td", { children: moment(del.date, moment.ISO_8601).format("dddd, MMMM Do YYYY, h:mma") }), _jsx("td", { children: del.attempts }), _jsx("td", { style: { width: 300 }, children: del.destinations }), _jsx("td", { style: { width: 300 }, children: (_a = del.sentDestinations) === null || _a === void 0 ? void 0 : _a.join("; ") })] }, del.id));
    }
    setCurrentPage(i) {
        this.setState({
            filterCriteria: Object.assign(Object.assign({}, this.state.filterCriteria), { page: i }),
        });
    }
    renderStatusIcon(error) {
        if (error) {
            return _jsx("span", { className: "fa fa-circle text-danger" });
        }
        return _jsx("span", { className: "fa fa-circle" });
    }
    renderFailed(index, count) {
        if (!count) {
            return null;
        }
        const option = [{ value: index, label: this.getErrorMessage(index) || "" }];
        return (_jsxs("div", { children: [_jsxs("button", { className: "pl-0 btn btn-link", onClick: () => this.filterOnErrorCode(option), children: [_jsxs("span", { className: "text-danger", children: ["(", count, ")\u00A0"] }), this.getErrorMessage(index) || index] }), _jsx("button", { className: "ml-2 btn btn-danger btn-sm", onClick: () => {
                        this.setState({
                            isModalOpen: true,
                            modalMsg: {
                                errorCode: index,
                                errorString: this.getErrorMessage(index),
                            },
                        });
                    }, children: "Manually Override" }), _jsx(ConfirmOverrideModal, { isOpen: this.state.isModalOpen && this.state.modalMsg.errorCode === index, modalId: `confirmOverrideModal-${index}`, onCloseModal: this.closeModal, modalMsg: this.state.modalMsg, overrideDeliveries: this.overrideDeliveries })] }, index));
    }
    renderPager() {
        return (_jsxs("div", { className: "d-flex align-items-center", children: [_jsx(AvisoPager, { currentPage: this.state.filterCriteria.page, hidePageNumbers: false, totalPages: this.state.totalCount / this.state.pageSize, noChevron: true, setCurrentPage: this.setCurrentPage }), _jsx("div", { className: "ml-2", children: _jsx(Busy, { isBusy: this.state.loading }) })] }));
    }
    closeModal() {
        this.setState({ isModalOpen: false });
        this.getMessageStatuses();
        this.fetchDeliveries(this.state.filterCriteria);
    }
    render() {
        return (_jsxs(_Fragment, { children: [_jsx("div", { className: "navbar-secondarynav fixed fit-to-parent border-right", role: "navigation", style: { width: "100%" }, children: _jsxs("a", { href: "https://support.watermarkinsights.com/hc/en-us/articles/11305681899547-Message-Report-Error-Codes", className: "btn btn-link", title: "Need Help", target: "_blank", rel: "noopener noreferrer", children: [_jsx("span", { className: "fa fa-info-circle", "aria-hidden": "true" }), " Help"] }) }), _jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "card mb-3 card-body col-12", children: _jsxs("section", { id: "search", children: [_jsxs("h3", { className: "d-inline-block mr-2", children: [this.state.messageCountByStatus.failed.length &&
                                                this.renderStatusIcon(true), "\u00A0Failed Messages"] }), _jsx("ul", { children: this.state.messageCountByStatus.failed.map((x) => this.renderFailed(x[0], x[1])) })] }) }), _jsxs("div", { className: "card mb-3 card-body col-12", role: "alert", children: [_jsxs("div", { className: "row", children: [_jsxs("div", { className: "col-12 col-md-6 form-group", children: [_jsx("label", { className: "control-label", children: "From" }), _jsx(PersonLookup, { defaultIds: [], onChange: (x) => this.filterOnPerson("from", x) })] }), _jsxs("div", { className: "col-12 col-md-6 form-group", children: [_jsx("label", { className: "control-label", children: "To" }), _jsx(PersonLookup, { defaultIds: [], onChange: (x) => this.filterOnPerson("to", x) })] })] }), _jsxs("div", { className: "row", children: [_jsxs("div", { className: "col-12 col-md-6 form-group", children: [_jsx("label", { className: "control-label", htmlFor: "messageReportStatus", children: "Status" }), _jsx(DeprecatedSelect, { "aria-label": "Status", id: "messageReportStatus", multi: true, name: "form-field-name", onChange: this.filterOnStatus, options: [
                                                        { value: 1, label: "READY" },
                                                        { value: 2, label: "SENDING" },
                                                        { value: 3, label: "SENT" },
                                                        { value: 4, label: "DELIVERED" },
                                                        { value: 5, label: "FAILED" },
                                                        { value: 6, label: "PENDING" },
                                                        { value: 7, label: "READ" },
                                                        { value: 8, label: "PROCESSING" },
                                                        { value: 9, label: "MANUAL_OVERRIDE" },
                                                    ], value: this.state.filterCriteria.status })] }), _jsxs("div", { className: "col-12 col-md-6 form-group", children: [_jsx("label", { className: "control-label", htmlFor: "messageReportError", children: "Error" }), _jsx(DeprecatedSelect, { "aria-label": "Error", id: "messageReportError", multi: true, name: "form-field-name", onChange: this.filterOnErrorCode, options: Array.from(errorCodes).map((x) => ({
                                                        value: x[0],
                                                        label: x[1],
                                                    })), value: this.state.filterCriteria.errorCodes })] })] }), _jsx("div", { className: "row", children: _jsx("div", { className: "col-12", children: _jsx(DateRangePicker, { block: true, enableOutsideDays: true, endDate: this.state.filterCriteria.endDate, endDateId: "endDate", focusedInput: this.state.focusedInput, isOutsideRange: () => false, onDatesChange: this.filterOnDate, onFocusChange: (focusedInput) => this.setState({ focusedInput }), showClearDates: true, startDate: this.state.filterCriteria.startDate, startDateId: "startDate" }) }) })] }), _jsxs("div", { className: "mb-3", children: [_jsxs("table", { className: "table table-striped table-bordered", children: [_jsx("thead", { children: _jsx("tr", { children: this.tableHeaders.map(({ id, name }) => {
                                                    var _a, _b, _c;
                                                    return (_jsx(SortableTH, { sort: ((_a = this.state.filterCriteria) === null || _a === void 0 ? void 0 : _a.setSort) === id &&
                                                            (((_b = this.state.filterCriteria) === null || _b === void 0 ? void 0 : _b.asc) ? "asc" : "desc"), onClick: () => this.setSort(id), isLoading: ((_c = this.state.filterCriteria) === null || _c === void 0 ? void 0 : _c.setSort) === id &&
                                                            this.state.loading, children: name }, id));
                                                }) }) }), _jsx("tbody", { children: this.state.deliveries.map((del) => this.renderDeliveryRow(del)) })] }), this.renderPager()] }), _jsx(Switch, { children: _jsx(Route, { component: MessageDetails, path: getMessageReportDetailsRoute() }) })] })] }));
    }
}
export default MessageReport;
